import React, { useContext, useEffect, useState, createContext } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import { auth, db } from "../firebase"; // adjust path if needed

const AuthContext = createContext();

export function useAuth() {
  return useContext(AuthContext);
}

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // Firebase user object
  const [role, setRole] = useState(null); // "user" | "accountant" | "admin"
  const [loading, setLoading] = useState(true); // To block routes while loading

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (firebaseUser) => {
      setUser(firebaseUser);

      if (firebaseUser) {
        try {
          const docRef = doc(db, "users", firebaseUser.uid);
          const docSnap = await getDoc(docRef);
          if (docSnap.exists()) {
            const userData = docSnap.data();
            setRole(userData.role || "user"); // fallback to "user"
          } else {
            setRole("user");
          }
        } catch (err) {
          console.error("Failed to fetch user role:", err);
          setRole("user");
        }
      } else {
        setRole(null);
      }

      setLoading(false);
    });

    return unsubscribe;
  }, []);

  const value = {
    user, // Firebase user object
    role, // Custom role from Firestore
    loading, // To guard routes while auth is initializing
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}
